import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Snackbar from "@material-ui/core/Snackbar";
import { GetPurchases, GetBusReport, DeleteBusReport } from "../../fetchs";
import { Grid } from "@material-ui/core";
import DetailIcon from "@material-ui/icons/Details";
import CircularProgress from "@material-ui/core/CircularProgress";
import { ModalDetailOrder } from "../Useful/Useful";
import Modal from "@material-ui/core/Modal";
import { Button } from "@material-ui/core";
import moment from "jalali-moment";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./purchase-list.styles.css";
import { setGlobalCssModule } from "reactstrap/lib/utils";
import AlertDialog from "../Prompt/alert-dialog.component";
import DeleteIcon from "@material-ui/icons/Delete";

const headCells = [
  { id: "index", numeric: true, disablePadding: false, label: "شماره" },
  {
    id: "customerName",
    numeric: false,
    disablePadding: true,
    label: "عنوان ",
  },
  {
    id: "desc",
    numeric: false,
    disablePadding: true,
    label: "توضیحات ",
  },

  {
    id: "نام شغل",
    numeric: false,
    disablePadding: true,
    label: "  نام شغل",
  },
  {
    id: "adminName",
    numeric: false,
    disablePadding: true,
    label: "گزارش دهنده ",
  },
  { id: "date", numeric: false, disablePadding: true, label: "حذف" },
  // { id: "date", numeric: false, disablePadding: true, label: "اطلاعات مشتری" },
  // {
  //   id: "detail",
  //   numeric: false,
  //   disablePadding: true,
  //   label: " نمایش جشنواره",
  // },
  // {
  //   id: "detail",
  //   numeric: false,
  //   disablePadding: true,
  //   label: " نمایش محصولات",
  // },
];
function rand() {
  return Math.round(Math.random() * 20) - 10;
}

function getModalStyle() {
  const top = 50 + rand();
  const left = 50 + rand();

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    overflow: "scroll",
  },
  color: {
    color: "#635ee7",
    backgroundColor: "#2e1534",
  },
  color2: {
    color: "#bd5f00",
    backgroundColor: "#085025",
  },
  color3: {
    color: "#fff",
    backgroundColor: "#45B8AC",
  },
}));

const PurchaseList = (props) => {
  const [page, setpage] = useState(0);
  const [rowsPerPage, setrowsPerPage] = useState(20);
  const [rowsLength, setrowsLength] = useState(0);
  const [rows, setrows] = useState([]);
  const [loading, setloading] = useState(false);
  const [openSnackbar, setopenSnackbar] = useState(false);
  const [errorMessage, seterrorMessage] = useState("");
  const [alertDialog, setalertDialog] = useState(false);
  const classes = useStyles();
  // getModalStyle is not a pure function, we roll the style only on the first render
  const [modalStyle] = useState(getModalStyle);
  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [open2, setopen2] = useState(false);
  const [product, setproduct] = useState([]);
  const [tell, settell] = useState("");
  const [address, setaddress] = useState("");
  const [province, setprovince] = useState("");
  const [city, setcity] = useState("");
  const [deleteId, setdeleteId] = useState("");

  const [fesname, setfesname] = useState(null);

  const handleOpen = (goodsOrder) => () => {
    console.log(typeof goodsOrder);
    if (typeof goodsOrder === "string") {
      // JSON.parse(goodsOrder).map((item, index) => {
      setproduct(JSON.parse(goodsOrder));
      // });
    } else {
      setfesname(goodsOrder);
    }

    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen1 = (desc) => () => {
    desc ? setfesname(desc) : setfesname("توضیحات ثبت نشده است");
    setOpen1(true);
  };

  const handleClose1 = () => {
    setOpen1(false);
  };
  const handleOpen2 = (info, prov, city) => () => {
    prov ? setprovince(prov) : setprovince(" استان ثبت نشده است");
    city ? setcity(city) : setcity(" شهر ثبت نشده است");
    info && info.tell ? settell(info.tell) : settell("شماره تماس ثبت نشده است");
    info && info.address
      ? setaddress(info.address)
      : setaddress(" آدرس ثبت نشده است");
    setopen2(true);
  };

  const handleClose2 = () => {
    setopen2(false);
  };

  useEffect(() => {
    getPurchases();
  }, [page, rowsPerPage]);

  const handleCloseSnackbar = () => {
    setopenSnackbar(false);
  };

  const getPurchases = () => {
    setloading(true);
    GetBusReport(page, rowsPerPage)
      .then((response) => {
        setloading(false);

        return response.json();
      })
      .then((responseJson) => {
        setrows(responseJson.data);
        setrowsLength(responseJson.count);
      })
      .catch((error) => {
        setloading(false);
        console.error(error);
      });
  };

  const handleDelete = () => {
    setalertDialog(false);
    setloading(true);

    DeleteBusReport(deleteId)
      .then((response) => {
        setloading(false);
        if (response.status === 200) toast.success("گزارش با موفقیت حذف شد");
        else toast.error("خطای حذف گزارش");
        getPurchases();

        return response.json();
      })
      .then((responseJson) => {
        //   if (responseJson.Message)
        //     this.setState({
        //       errorMessage: responseJson.Message,
        //       openSnackbar: true,
        //     });
        // })
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handlePrepareDelete = (id) => {
    setdeleteId(id);
    setalertDialog(true);
  };
  const handleCloseDialog = () => {
    setalertDialog(false);
  };

  const handleChangePage = (event, newPage) => {
    setpage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setrowsPerPage(parseInt(event.target.value, 10));
    setpage(0);
  };
  // handleShowDetail = (id) => {
  //   GetPurchase(id)
  //     .then((response) => {
  //       setloading(false);
  //       return response.json();
  //     })
  //     .then((responseJson) => {
  //       if (responseJson.Message)
  //         this.setState({
  //           errorMessage: responseJson.Message,
  //           openSnackbar: true,
  //         });
  //       else this.setState({ detail: responseJson });
  //     })
  //     .catch((error) => {
  //       this.setState({ loading: false });
  //       console.error(error);
  //     });
  // };

  // isActive = (value) => {
  //   return value === this.state.filterBy ? "active" : "default";
  // };

  // emptyRows = () =>
  //   this.state.rowsPerPage -
  //   Math.min(
  //     this.state.rowsPerPage,
  //     this.state.rowsLength - this.state.page * this.state.rowsPerPage
  //   );

  return (
    <div className="root">
      <Paper className="paper">
        <Toolbar>
          <Grid item xs={12} sm={2}>
            <div className="title">
              {
                <Typography variant="h6" id="tableTitle">
                  لیست گزارش مشاغل
                </Typography>
              }
            </div>
          </Grid>
          <Grid item xs={12} sm={10}></Grid>
        </Toolbar>
        <div className="tableWrapper">
          <Table
            stickyHeader
            className="table"
            aria-labelledby="tableTitle"
            size={"medium"}
          >
            <TableHead>
              <TableRow>
                {headCells.map((headCell) => (
                  <TableCell
                    key={headCell.id}
                    align={"center"}
                    padding={headCell.disablePadding ? "none" : "default"}
                  >
                    <TableSortLabel active={false}>
                      {headCell.label}
                    </TableSortLabel>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row, index) => {
                // let goodssoredr = row.goodsOrder.json();
                // if (row.goodsOrder) {
                //   let gorder = JSON.parse(row.goodsOrder);
                // }
                return (
                  <TableRow hover tabIndex={-1} key={row.id}>
                    <TableCell align="center">
                      {page * rowsPerPage + index + 1}
                    </TableCell>
                    <TableCell align="center">{row.title}</TableCell>
                    <TableCell align="center">
                      <Button
                        className={classes.color2}
                        variant={"contained"}
                        color="warning"
                        type="button"
                        // disabled={!row.festival}
                        onClick={handleOpen1(row.desc)}
                      >
                        توضیحات
                      </Button>
                      <Modal open={open1} onClose={handleClose1}>
                        <div style={modalStyle} className={classes.paper}>
                          <>
                            <div className="text-right">
                              <b> توضیحات:</b> {fesname}
                            </div>
                          </>
                        </div>
                      </Modal>
                    </TableCell>
                    <TableCell align="center">{row.business.name}</TableCell>

                    <TableCell align="center">
                      {row.user.name} {row.user.family}
                    </TableCell>
                    <TableCell align="center">
                      {/* <Link to={`/main/city/${row.id}`}>
                          <EditIcon color='primary' />
                        </Link> */}
                      <DeleteIcon
                        className="deleteIcon"
                        onClick={() => handlePrepareDelete(row.id)}
                      />
                    </TableCell>

                    {/* <TableCell align="center">
                      {moment(row.date, "YYYY/MM/DD")
                        .locale("fa")
                        .format("YYYY/MM/DD")}
                    </TableCell> */}
                    {/* <TableCell align="center">
                      <Button
                        className={classes.color3}
                        variant={"contained"}
                        color="warning"
                        type="button"
                        disabled={!row.customer}
                        onClick={handleOpen2(
                          row.customer,
                          row.customerProvince,
                          row.customerCity
                        )}
                      >
                        نمایش اطلاعات
                      </Button>
                      <Modal open={open2} onClose={handleClose2}>
                        <div style={modalStyle} className={classes.paper}>
                          <>
                            <div className="text-right">
                              <b> شماره تماس:</b> {tell}
                            </div>
                            <div className="text-right">
                              <b> استان:</b> {province}
                            </div>
                            <div className="text-right">
                              <b> شهر:</b> {city}
                            </div>
                            <div className="text-right">
                              <b> آدرس:</b> {address}
                            </div>
                          </>
                        </div>
                      </Modal>
                    </TableCell> */}
                    {/* <TableCell align="center">
                      <Button
                        className={classes.color2}
                        variant={"contained"}
                        color="warning"
                        type="button"
                        // disabled={!row.festival}
                        onClick={handleOpen1(row.desc)}
                      >
                        توضیحات
                      </Button>
                      <Modal open={open1} onClose={handleClose1}>
                        <div style={modalStyle} className={classes.paper}>
                          <>
                            <div className="text-right">
                              <b> جشنواره:</b> {fesname}
                            </div>
                          </>
                        </div>
                      </Modal>
                    </TableCell> */}
                    {/* <TableCell align="center">
                      <Button
                        className={classes.color}
                        variant={"contained"}
                        color="warning"
                        type="button"
                        disabled={!row.goodsOrder || row.goodsOrder == "[]"}
                        onClick={handleOpen(row.goodsOrder)}
                      >
                        نمایش محصولات
                      </Button>
                      <Modal open={open} onClose={handleClose}>
                        <div style={modalStyle} className={classes.paper}>
                          {product &&
                            product.map((item, index) => {
                              return (
                                <>
                                  <div className="text-right">
                                    <b>نام کالا:</b> {item.name}
                                  </div>
                                  <div className="text-right">
                                    <b>تعداد:</b> {item.number}
                                  </div>
                                  <div className="text-right">
                                    <b>نوع پرداخت:</b> {item.paymentType}
                                  </div>
                                  <hr />
                                </>
                              );
                            })}
                        </div>
                      </Modal>
                    </TableCell> */}
                    {/* {row.goodsOrder &&
                      JSON.parse(row.goodsOrder).map((item, index) => {
                        return (
                          <TableCell>
                            <ModalDetailOrder
                              buttonLabel='اطلاعات بیشتر '
                              title=' ا'
                              name={
                                item.name ? item.name : "نام کالا ثبت نشده است"
                              }
                              number={
                                item.number ? item.number : "تعداد ثبت نشده است"
                              }
                              paymentType={
                                item.paymentType
                                  ? item.paymentType
                                  : "نوع پرداخت  ثبت نشده است"
                              }
                            ></ModalDetailOrder>
                          </TableCell>
                        );
                      })} */}
                  </TableRow>
                );
              })}
              {/* {this.emptyRows > 0 && (
                <TableRow style={{ height: 49 * this.emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )} */}
            </TableBody>
          </Table>
        </div>
        {loading && <CircularProgress size={24} className="buttonProgress" />}
        <AlertDialog
          open={alertDialog}
          title={`اخطار`}
          body={`آیا از حذف جشنواره اطمینان دارید؟`}
          handleYes={handleDelete}
          handleNo={handleCloseDialog}
        />
        <TablePagination
          rowsPerPageOptions={[20, 50, 100]}
          component="div"
          count={rowsLength}
          rowsPerPage={rowsPerPage}
          page={page}
          backIconButtonProps={{
            "aria-label": "previous page",
          }}
          nextIconButtonProps={{
            "aria-label": "next page",
          }}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        autoHideDuration={3000}
        open={openSnackbar}
        ContentProps={{
          "aria-describedby": "message-id",
          class:
            "error MuiTypography-root MuiPaper-root MuiPaper-elevation6 MuiSnackbarContent-root MuiTypography-body2",
        }}
        message={<span id="message-id"> {errorMessage} </span>}
        onClose={() => handleCloseSnackbar(false)}
      />
    </div>
  );
};
export default PurchaseList;
